export const SEARCH_ALL = 'SEARCH_ALL' as const;
export const SEARCH_ALL_PENDING = 'SEARCH_ALL_PENDING' as const;
export const SEARCH_ALL_FULFILLED = 'SEARCH_ALL_FULFILLED' as const;
export const SEARCH_ALL_REJECTED = 'SEARCH_ALL_REJECTED' as const;
